<template>
  <el-dialog
    :title="product.productId ? '编辑商品' : '新增商品'"
    :visible.sync="visible"
    width="400px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose"
  >
    <el-form
      ref="ruleForm"
      :model="product"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="企业名称："
        prop="vendorName">
        {{ product.vendorName }}
      </el-form-item>
      <el-form-item
        label="商品名称："
        prop="productName">
        <el-input v-model="product.productName"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'ProductsEditModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      product: {
        vendorId: null,
        vendorName: null,
        productId: null,
        productName: ''
      },
      rules: {
        productName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch =
            this.product.productId ? 'updateproduct' : 'addproduct'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: this.product,
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    init(options = {}) {
      this.product = {
        ...this.product,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
